import { Range } from '../entities/range-custom-type';
import { Dollar } from './dollar-model';
import { DropdownModel } from './dropdown-model';
import { DropDownStringModel } from './dropdown-string-model';
import { Number } from './number-model';
import { Daterange } from './Daterange.model';

export class Search {
    globalSearch: string;
    orderBy: string;
    month: DropdownModel = null;
    year: number = null;
    category1: DropdownModel = null;
    category2: DropdownModel = null;
    category3: DropdownModel = null;
    operationalStatus: DropdownModel = null;
    assured: string;
    landOffshore: DropdownModel = null;
    location: string;
    country: DropdownModel = null;
    assetCategory: DropdownModel = null;
    lossType: DropdownModel = null;
    cause: DropdownModel = null;
    area: DropdownModel = null;
    source: string;
    adjuster: string;
    waterDepthCategory: DropDownStringModel = null;
    buildYearCategory: DropdownModel = null;
    waterDepth: number;
    builtYear: number;
    pdClaim: Dollar = new Dollar();
    oeeClaim: Dollar = new Dollar();
    biClaim: Dollar = new Dollar();
    totalClaim: Dollar = new Dollar();
    totalIndexedClaim: Dollar = new Dollar();
    totalIndexedOEEClaim: Dollar = new Dollar();
    ctl: boolean;
    createdDate: Daterange = new Daterange();
    updatedDate: Daterange = new Daterange();
    ratingArea: DropdownModel = null;
    wellType: DropdownModel = null;
    drillingStatus: DropdownModel = null;
    ugbo: DropdownModel = null;
    usLocationCode: DropdownModel = null;
    shaleWell: DropdownModel = null;
    devExp: DropdownModel = null;
    shaleInformation: DropdownModel = null;
    lossDepth: number;
    lossDepthCategory: DropDownStringModel = null;
    ptd: number;
    outageDays: number;
    tow: DropdownModel = null;
    ratedWd: number;
    generation: DropdownModel = null;
    rebuiltYear: number;
    productInformation: DropdownModel = null;
    actualPDLiabCategory: Range = null;
    actualOEECategory: Range = null;
    actualTotalCategory: Range = null;
    indexedPDLiabCategory: Range = null;
    indexedOEECategory: Range = null;
    indexedTotalCategory: Range = null;
    upDownPower: DropdownModel = null;
    field: DropdownModel = null;
    gomArea: DropdownModel = null;
    urn: Number = new Number();
    adjusterIndividual: DropdownModel = null;
    adjusterFileRef: string;
    close: boolean;
    transit: boolean;
    willis: DropdownModel = null;
    oilUrn: string;
    oilMulti: boolean;
    event: DropdownModel = null;
    plantBuildYear: number;
    plantCapacity: string;
    equipmentType: DropdownModel = null;
    model: DropdownModel = null;
    modelBuildYear: number;
    modelOEM: DropdownModel = null;
    countryManufacture: DropdownModel = null;
    incomplete: boolean;
    dateOfLoss: Daterange = new Daterange();
}



// WEBPACK FOOTER //
// ./src/app/modules/el-data-management/eldm-filters/entities/search-input.ts